import { mapString } from 'lib/utilities';

import { FORMATTING_CHARACTERS } from '../../regexes';

export const getHiddenValue = (value, mask) =>
  mapString(value, (_, index) => (FORMATTING_CHARACTERS.includes(mask[index]) ? mask[index] : '●'));
